/**
 *  Created by long.wang on 2020/7/28
 */

export default [{
  path: '/landing/lycfAuth',
  name: 'lycf-auth-landing',
  component: resolve => {
    require(['../views/landing/lycfAuth'], resolve)
  },
  meta: {
    title: '羚羊财富'
  }
}]